// extracted by mini-css-extract-plugin
module.exports = {"audio_player":"AudioPlayerEvent_audio_player__dDem-","button":"AudioPlayerEvent_button__35cTz"};